import { createClient } from "@supabase/supabase-js";

// ──────────────────────────────────────────────────────────────────────────────
// Paste your Project URL and anon/public key from:
//   Supabase Dashboard → Project Settings → API
// ──────────────────────────────────────────────────────────────────────────────
const SUPABASE_URL = "https://akzxjytvwndjjkjsyyvv.supabase.co";
const SUPABASE_ANON_KEY = "sb_publishable_yQcEknDGxrnOlw2IXvLszQ_fr-STlYc"; // ← replace this

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
